<template>
<v-card>
    <v-data-table :loading="loading" :page.sync="page" @page-count="pageCount = $event" :items="items" :headers="headers" hide-default-footer>
        <template v-slot:item.id="{ item }">
            <span class="table-complete-name">{{item.tutor_invoice_id}}</span>
        </template>
        <template v-slot:item.name="{item}">
            <span class="table-complete-status st-success" v-if="typeof item.tutor != 'undefined' && item.tutor != null && item.tutor.length > 0">{{item.tutor.tutor_fname}}</span>
        </template>

        <template v-slot:item.status="{item}">
            <span class="table-complete-status st-error">{{item.tutor_invoice_status}}</span>
        </template>

        <template v-slot:item.start_date="{item}">
            <span v-html="formatDate(item.start_date)"></span>
        </template>

        <template v-slot:item.end_date="{item}">
            <span v-html="formatDate(item.end_date)"></span>
        </template>

        <template v-slot:item.amount="{ item }">
            <span class="table-complete-name">{{item.amount}}</span>
        </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
        <span class="pa-2">
            Total Enquiries
            <span :style="{'color':this.$vuetify.theme.themes.light.primary}">{{count}}</span>
        </span>
        <v-spacer></v-spacer>
        <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
    </div>
</v-card>
</template>

<script>
import DataTableMixin from "../../../mixins/dataTable";
import moment from "moment";
export default {
    name: "PaidTable",
    components: {},
    mixins: [DataTableMixin],
    data() {
        return {
            loading: true,
            page: 1,
            totalPages: 1,
            pageCount: 3,
            itemsPerPage: 10,
            headers: [{
                    text: "Srno.",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Start Date",
                    value: "start_date",
                    sortable: true
                },
                {
                    text: "End Date",
                    value: "end_date",
                    sortable: true
                },
                {
                    text: "Total Hours",
                    value: "total_hours",
                    sortable: false
                },
                {
                    text: "Amount",
                    value: "amount",
                    sortable: false
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: false
                },
            ],
        };
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        makeQueryParams() {
            const user = JSON.parse(localStorage.getItem("user"));
            return {
                ...this.formQueryParams(),
                tutor: user.id,
                status: 1,
            };
        },
        getItems() {
            let user = JSON.parse(localStorage.getItem('user'));
            this.loading = true;
            axios
                .get(apiRoutes.accounts.invoices.tutors.url, {
                    params: {
                        type: 'pending',
                        id: user.id
                    }
                })
                .then((response) => {
                    this.loading = false;
                    this.formalizeTable(response.data);
                    this.totalPages = Math.ceil(response.data.total / 10);
                });
        },
    },
    mounted() {
        this.getItems();
    },
};
</script>

<style lang="scss">
.v-data-table-header th span {
    font: 300 14px Gotham;
    font-family: "Gotham Narrow";
    color: #8898aa;
}

.table-complete {
    &-srno {
        font: 500 14px/13px Gotham;
        color: #172b4d;
    }

    &-name {
        display: block;
        font: 500 14px/13px Gotham;
        color: #6a158e;
    }

    &-status {
        font: 600 14px/17px Gotham;
        color: #129b11;

        &.st-error {
            color: #e41b1bf7;
        }
    }
}
</style>
